export const serviceData = [
    {
        img: "track",
        title: "UNSERE DIENSTE",
        subtitle: "Kostenlose Lieferung",
    },

    {
        img: "gift",
        title: "GUTSCHEINE",
        subtitle: "Gutscheine für alle Anlässe",
    },

    {
        img: "credit-card",
        title: "BEZAHLUNG",
        subtitle: "Alle Zahlungsarten möglich",
    },

    {
        img: "guarantee",
        title: "GARANTIE",
        subtitle: "Auf alle unsere Produkte",
    },
];